import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import {onMounted, PropType, ref, watch} from "vue";
import {toTitleCase} from "@/helpers/utilities/utility";
import {getEntityStateColour, getStatusClass} from "@/components/Atomic/BAtoms/schools/SchoolStateHelpers"


export default /*#__PURE__*/_defineComponent({
  __name: 'SchoolStateFilterButtons',
  props: {
  typeOptions: Array as PropType<String[]>,
  modelValue: {
    type: String,
  },
  styleClass: String,
},
  emits: ['update'],
  setup(__props, { emit: __emit }) {


const props = __props

const emit = __emit

const modelValue = ref(props.modelValue)
const typeOptions = ref(props.typeOptions)

const selectAllOption = ref<string>('All')

watch(() => modelValue.value, (newValue) => {
  if (newValue === ''){
    modelValue.value = selectAllOption.value
  }
  if (newValue === selectAllOption.value){
    emit('update')
    return
  }
  emit('update', newValue)
}, {immediate: true})


return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.styleClass)
  }, [
    _createVNode(_component_Button, {
      class: _normalizeClass([modelValue.value === 'All' ? _unref(getStatusClass)(selectAllOption.value) : 'bg-transparent text-dark-blue border border-dark-blue', "px-10 py-1.5 rounded-md shadow-md"]),
      value: _unref(toTitleCase)(selectAllOption.value),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (modelValue.value = selectAllOption.value))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(selectAllOption.value), 1)
      ]),
      _: 1
    }, 8, ["class", "value"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, (option) => {
      return (_openBlock(), _createBlock(_component_Button, {
        class: _normalizeClass([modelValue.value === option ? _unref(getStatusClass)(option) : 'border text-dark-blue border-dark-blue', "px-10 py-1.5 rounded-md shadow-md"]),
        value: _unref(toTitleCase)(option),
        onClick: ($event: any) => (modelValue.value = option)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(toTitleCase)(option)), 1)
        ]),
        _: 2
      }, 1032, ["class", "value", "onClick"]))
    }), 256))
  ], 2))
}
}

})